import type { CSSProperties } from 'react';

import classes from './CurrencyFlag.module.css';

type Props = {
    currencyCode?: string;
    countryCode?: string;
    size?: number;
    style?: CSSProperties;
    currencyCodeStyling?: Record<string, unknown>;
    currencyStyle?: Record<string, unknown>;
    condensed?: boolean;
};

const CurrencyFlag = (props: Props) => {
    if (props.currencyCode) {
        return (
            <div
                className={`${classes.currencyContainer} ${props.condensed ? classes.condensed : ''}`}
                style={{ width: props.size, height: props.size, ...props.style }}
            >
                <div
                    className={classes.currency}
                    style={{
                        width: props.size,
                        height: props.size,
                        ...props.currencyStyle,
                    }}
                >
                    <img
                        src={`/img/currencies/${props.currencyCode}.svg`}
                        alt={props.currencyCode}
                        style={{
                            height: props.size /* height is the shorter dimension, so setting that to size so it fills the container */,
                        }}
                    />
                </div>
                <span className={`${classes.code}`} style={props.currencyCodeStyling}>
                    {props.currencyCode}
                </span>
            </div>
        );
    }
    if (props.countryCode) {
        return (
            <div className={classes.currencyContainer} style={props.style}>
                <div className={classes.currency} style={props.currencyStyle}>
                    <img src={`/img/flags/${props.countryCode}.svg`} alt={props.countryCode} />
                </div>
            </div>
        );
    }

    console.error('CurrencyFlag: No currencyCode or countryCode provided');
    return null;
};

export default CurrencyFlag;
